import axios from 'axios';
import type { ResolvedAiModelUseCase } from '@shared/models/ai/ai-models.model';

type ListResponse = {
  useCases: ResolvedAiModelUseCase[];
};

export const adminAiModelsApi = {
  list: () =>
    axios.get<ListResponse>('/admin/ai-models').then((r) => r.data.useCases),
};
